import { API_BASE_URL } from "./config";
import type { WeatherTimeGroupResponse } from "./weather.types";

export interface WorkerSiteResponse {
  uuid: string;
  name: string;
  address?: string | null;
  region?: string | null;
  lat?: number | null;
  lon?: number | null;
  description?: string | null;
  constructionStartDate?: string | null;
  constructionEndDate?: string | null;
}

async function getWorkerSite(uuid: string): Promise<WorkerSiteResponse> {
  const res = await fetch(`${API_BASE_URL}/worker/${uuid}/site`, { cache: "no-store" });
  if (!res.ok) throw new Error(`현장 정보 조회 실패 (${res.status})`);
  const json = (await res.json()) as { data: WorkerSiteResponse };
  return json.data;
}

async function getWorkerWeather(uuid: string): Promise<WeatherTimeGroupResponse[]> {
  const res = await fetch(`${API_BASE_URL}/worker/${uuid}/weather`, { cache: "no-store" });
  if (!res.ok) throw new Error(`날씨 조회 실패 (${res.status})`);
  const json = (await res.json()) as { data: WeatherTimeGroupResponse[] };
  return json.data ?? [];
}

async function registerWorkerFcmToken(uuid: string, token: string): Promise<void> {
  const res = await fetch(`${API_BASE_URL}/worker/${uuid}/push/subscriptions`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, deviceLabel: navigator.userAgent }),
  });
  if (!res.ok) throw new Error(`FCM 토큰 등록 실패 (${res.status})`);
}

export const workerService = {
  getWorkerSite,
  getWorkerWeather,
  registerWorkerFcmToken,
};
